// extracted by mini-css-extract-plugin
module.exports = {"box":"box-V7yj_L2j","ad_box":"ad_box-2TGc9U6r clearfix","fl":"fl-3eLYp8BG fl","fr":"fr-2cq6tEfl fr","ad":"ad-8ETx2pLd"};